import { type ButtonProps as MuiButtonProps } from "@mui/material/Button";

import { BaseButton } from "../styles/ButtonStyles";

export type ButtonBackground = "fill" | "empty";

export interface AppButtonProps extends Omit<MuiButtonProps, "color"> {
  $background?: ButtonBackground;
  $bgcolor?: string;
  $width?: string;
  $slim?: boolean;
  "data-testid"?: string;
}

export function Button({
  children,
  variant = "contained",
  type = "button",
  $background = "fill",
  $bgcolor,
  $width = "100%",
  $slim = false,
  disableElevation = variant === "contained",
  ...rest
}: Readonly<AppButtonProps>) {
  return (
    <BaseButton
      variant={variant}
      type={type}
      disableElevation={disableElevation}
      $background={$background}
      $bgcolor={$bgcolor}
      $width={$width}
      $slim={$slim}
      {...rest}
    >
      {children}
    </BaseButton>
  );
}

export default Button;